var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-view"},[_c('div',{staticClass:"ma-12"},[_c('DataCard',{attrs:{"props":_vm.chart,"rows":"1","show-nav":"","hover-details":""},on:{"click":function($event){_vm.dialog=true}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }